import React, { useState } from "react";

import { Box, Button, Text } from "@metrea-ui/v2";
import { AppModal } from "../common/AppModal";
import { ModalShell } from "../common/ModalShell";
import { Stack } from "@metrea-ui/v2";

const ChildModal = (props) => {
	const [open, setOpen] = useState(false);
	const handleOpen = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};

	return (
		<React.Fragment>
			<Button onClick={handleOpen}>{props.buttonLabel}</Button>
			<AppModal
				open={open}
				onClose={handleClose}
				aria-labelledby="child-modal-title"
				aria-describedby="child-modal-description"
			>
				<Box>
					<ModalShell>
						<Box>
							<Stack>
								<Text textStyle="lg">{props.title}</Text>
								<p id="child-modal-description">{props.description}</p>
								{props.children}
								<Button onClick={handleClose}>Close Child Modal</Button>
							</Stack>
						</Box>
					</ModalShell>
				</Box>
			</AppModal>
		</React.Fragment>
	);
};

const NestedModal = (props) => {
	const [open, setOpen] = useState(true);

	const handleClose = () => {
		setOpen(false);
		props.onSetOpen(false);
	};

	return (
		<div>
			<AppModal
				open={open}
				onClose={handleClose}
				aria-labelledby="parent-modal-title"
				aria-describedby="parent-modal-description"
			>
				<Box>
					<ModalShell
						inset={props.inset}
						top="50%"
						left="50%"
						transform="translate(-50%, -50%)"
						// Keep legacy callers stable: explicit width/height should size the shell,
						// while max-height remains the default safety cap when height is omitted.
						h={props.height}
						w={props.width || "500px"}
						maxW={props.width || 500}
						maxH={props.maxHeight || (props.height ? undefined : "80vh")}
						minH={props.minHeight ?? 480}
					>
						<Box>
							<Stack>
								<Text textStyle="lg">{props.title}</Text>
								{props.children}
								{props.child && (
									<ChildModal
										buttonLabel={props.childButtonLabel}
										title={props.childTitle}
										description={props.childDescription}
										width={props.childWidth || props.width}
										height={props.childHeight || props.height}
									/>
								)}
							</Stack>
						</Box>
					</ModalShell>
				</Box>
			</AppModal>
		</div>
	);
};

export default NestedModal;
